/**
 * Returns a stable identity string for a code group.
 *
 * @param {Object} codeGroup
 * @returns {string}
 */
export const getCodeGroupIdentity = (codeGroup) => {
  if (!codeGroup) {
    return "";
  }

  if (codeGroup.codeGroupKey != null) {
    return `key:${codeGroup.codeGroupKey}`;
  }

  if (codeGroup.codeGroupId != null) {
    return `id:${codeGroup.codeGroupId}`;
  }

  return `name:${codeGroup.codeGroupType || ""}:${codeGroup.codeGroupName || ""}`;
};

export const CODE_GROUP_APPROVED_STATUS = "Approved";

/**
 * Builds the user-facing message for an unapproved code group.
 *
 * @param {string} codeGroupName
 * @returns {string}
 */
export const unapprovedCodeGroupMessage = (codeGroupName) =>
  `${codeGroupName || "Code Group"} must be approved before submitting Policy Coding for review`;

/**
 * Collects code groups whose status is not Approved, preserving input order
 * (procedure groups first, then diagnosis groups).
 *
 * @param {Array<Object>} procedureCodeGroups
 * @param {Array<Object>} diagnosisCodeGroups
 * @returns {Array<{ codeGroupName: string, codeGroupType: string }>}
 */
export const getUnapprovedCodeGroups = (
  procedureCodeGroups = [],
  diagnosisCodeGroups = []
) => {
  const isApproved = (codeGroup) =>
    String(codeGroup?.codeGroupStatus ?? "") === CODE_GROUP_APPROVED_STATUS;

  return [...(procedureCodeGroups || []), ...(diagnosisCodeGroups || [])]
    .filter((codeGroup) => codeGroup && !isApproved(codeGroup))
    .map((codeGroup) => ({
      codeGroupName: codeGroup.codeGroupName,
      codeGroupType: codeGroup.codeGroupType,
    }));
};
